export const LOADING_USERS = 'LOADING_USERS';
export const FETCH_USERS = 'FETCH_USERS';
export const CREATE_USER = 'CREATE_USER';
export const GET_WALLET_BALANCE  = "GET_WALLET_BALANCE";
export const GET_ASSIGNED_PHONE_NUMBER = "GET_ASSIGNED_PHONE_NUMBER";
export const GET_REFERRAL_CODE = "GET_REFERRAL_CODE";
export const GET_USERS_IN_WORKGROUP = "GET_USERS_IN_WORKGROUP";
export const GET_TOTAL_USERS = "GET_TOTAL_USERS";
export const GET_RECENT_CALLS = "GET_RECENT_CALLS";
export const GET_WORKGROUPS_USER_BELONGS_TO = "GET_WORKGROUPS_USER_BELONGS_TO";